import http from "infra/http";
import { useQuery } from "react-query";
import { UserEndereco } from "../typings/user";


export default function useEndereco() {
  return useQuery("/v1/auth/endereco", async () => {
    const { data } = await http.get<UserEndereco>("/v1/auth/endereco");

    return data;
  });
}
